import React, { useState, useEffect } from "react";
import axios from "axios";
import { format } from "date-fns";
import { useShoppingContext } from "../../../../context/ShoppingContext";

const AddProduccionHuevosForm = () => {
  const {
    granjaActiva,
    aves,
    selectedAve,
    setLoading,
    fetchProduccionHuevos,
    fetchTiposHuevos,
    tiposHuevos = [], // Asegura que sea siempre un array vacío si está undefined o null
    setShowAddProduccion,
    renderDateTitle,
    setSelectedAve,
  } = useShoppingContext();

  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    fecha: format(new Date(), "yyyy-MM-dd"),
    id_ave: selectedAve ? selectedAve.id : "",
    granjaId: granjaActiva,
    huevos: {},
    total: 0,
  });

  useEffect(() => {
    fetchTiposHuevos();
  }, [fetchTiposHuevos]);

  // Reset formData and go to Step 1
  const resetFormData = () => {
    setFormData({
      fecha: format(new Date(), "yyyy-MM-dd"),
      id_ave: "",
      granjaId: granjaActiva,
      huevos: {},
      total: 0,
    });
    setStep(1);
  };

  const handleSelectAve = (aveId) => {
    const selectedAveObject = aves.find((ave) => ave.id === parseInt(aveId));
    setSelectedAve(selectedAveObject);
    setFormData((prevData) => ({ ...prevData, id_ave: aveId }));
  };

  const handleInputChange = (e, tipoHuevoId) => {
    const { value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      huevos: { ...prevData.huevos, [tipoHuevoId]: Number(value) || 0 },
    }));
  };

  const calculateTotal = () => {
    const total = Object.values(formData.huevos).reduce(
      (acc, cantidad) => acc + cantidad,
      0
    );
    setFormData((prevData) => ({ ...prevData, total }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/produccion-huevos`,
        formData
      );
      setLoading(false);
      fetchProduccionHuevos();
      setShowAddProduccion(false);
      resetFormData();
      alert("Producción registrada exitosamente");
    } catch (error) {
      setLoading(false);
      alert("Hubo un error al registrar la producción");
      console.error(error);
    }
  };

  useEffect(() => {
    calculateTotal();
  }, [formData.huevos]);

  const handleNextStep = () => setStep((prevStep) => prevStep + 1);
  const handlePreviousStep = () => setStep((prevStep) => prevStep - 1);

  return (
    <div className="add-ave-form-container">
      <div className="add-ave-form">
        <h2>Registrar Producción de Huevos</h2>

        {step === 1 && (
          <div className="form-group">
            <label>Selecciona un Ave</label>
            <select
              onChange={(e) => handleSelectAve(e.target.value)}
              className="form-control"
            >
              <option value="">Seleccione un ave</option>
              {aves?.map((ave) => (
                <option key={ave.id} value={ave.id}>
                  {ave?.nombre}
                </option>
              ))}
            </select>
            <div className="add-ave-form-buttons">
              <button
                type="button"
                className="btn btn-green-outline"
                onClick={() => setShowAddProduccion(false)}
              >
                Cancelar
              </button>
              <button
                type="button"
                className="btn btn-green"
                onClick={handleNextStep}
                disabled={!formData.id_ave}
              >
                Siguiente
              </button>
            </div>
          </div>
        )}

        {step === 2 && (
          <div className="form-group">
            <label>Fecha de Producción</label>
            <input
              type="date"
              value={formData.fecha}
              onChange={(e) =>
                setFormData({ ...formData, fecha: e.target.value })
              }
              className="form-control"
              max={format(new Date(), "yyyy-MM-dd")}
              required
            />
            <div className="add-ave-form-buttons">
              <button
                type="button"
                className="btn btn-green-outline"
                onClick={handlePreviousStep}
              >
                Retroceder
              </button>
              <button
                type="button"
                className="btn btn-green"
                onClick={handleNextStep}
              >
                Siguiente
              </button>
            </div>
          </div>
        )}

        {step === 3 && (
          <form onSubmit={handleSubmit}>
            <p>
              {selectedAve?.nombre} | {selectedAve?.especie} |{" "}
              {selectedAve?.saldo} aves | semana {selectedAve?.edad_actual}
            </p>
            <p>{renderDateTitle(formData.fecha)}</p>
            {tiposHuevos?.map((tipo) => (
              <div key={tipo.id} className="form-group">
                <label>{tipo?.nombre}</label>
                <input
                  type="number"
                  min="0"
                  value={formData.huevos[tipo.id] || ""}
                  onChange={(e) => handleInputChange(e, tipo.id)}
                  className="form-control"
                  placeholder={`Cantidad de ${tipo?.nombre}`}
                  required
                />
              </div>
            ))}
            <div className="form-group">
              <label>Total</label>
              <input
                type="number"
                readOnly
                value={formData.total}
                className="form-control"
              />
            </div>
            <div className="add-ave-form-buttons">
              <button
                type="button"
                className="btn btn-green-outline"
                onClick={handlePreviousStep}
              >
                Retroceder
              </button>
              <button type="submit" className="btn btn-green">
                Registrar Producción
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default AddProduccionHuevosForm;
